import { useState } from "react";
import { Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

export function Pill({ variant = "", children, testid }) {
  return (
    <span className={`pill ${variant}`} data-testid={testid}>
      {children}
    </span>
  );
}

export function DaysLeft({ days, total = 60 }) {
  const pct = Math.max(6, Math.min(100, Math.round((days / total) * 100)));
  let tone = "";
  if (days <= 7) tone = "crit";
  else if (days <= 15) tone = "soon";
  return (
    <span className={`days ${tone}`}>
      <span className="bar">
        <i style={{ width: `${pct}%` }} />
      </span>
      <span className="n">{days}</span>
    </span>
  );
}

export function Banner({ variant = "info", icon, children, style }) {
  return (
    <div className={`banner ${variant}`} style={style}>
      {icon && <span className="b-ic">{icon}</span>}
      <div>{children}</div>
    </div>
  );
}

export function Rid({ registrationId }) {
  return (
    <Link className="rid" to={`/candidates/${registrationId}`} data-testid={`candidate-link-${registrationId}`}>
      {registrationId}
    </Link>
  );
}

export function CompletedState({ label = "Completed", testid }) {
  return (
    <span className="done-state" data-testid={testid}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
      {label}
    </span>
  );
}

export function StatusPill({ status, label }) {
  const map = {
    interview_waiting: "waiting",
    interview_invited: "invited",
    interview_confirmed: "confirmed",
    checked_in: "checkedin",
    preview_complete: "previewdone",
    awaiting_employer: "awaiting",
    hire_approved: "approved",
    employer_hold: "talentpool",
    future_consideration: "talentpool",
    onboarding: "onboarding",
    converted: "converted",
    not_selected: "notselected",
    withdrawn: "withdrawn",
    pool_archived: "archived",
    registered: "registered",
  };
  return <Pill variant={map[status] || ""} testid={`status-${status}`}>{label}</Pill>;
}

export function PasswordInput({ value, onChange, testid, autoComplete, placeholder, className = "auth-input" }) {
  const [show, setShow] = useState(false);
  return (
    <div className="pw-wrap">
      <input className={className} type={show ? "text" : "password"} value={value} onChange={onChange}
        autoComplete={autoComplete} placeholder={placeholder} data-testid={testid} />
      <button type="button" className="pw-toggle" onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"} title={show ? "Hide password" : "Show password"}
        data-testid={testid ? `${testid}-toggle` : "pw-toggle"}>
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}

export function ContactFooter() {
  return (
    <div className="contact-footer" data-testid="mihp-contact-footer">
      <div className="cf-org">Make It Happen Philly — Human Resources</div>
      <div className="cf-line">
        <a href="tel:+12676411703">Call 267-641-1703 ext. 6</a>
        <span className="cf-sep">·</span>
        <a href="sms:+12027730218">Text (202) 773-0218</a>
      </div>
      <div className="cf-line"><a href="https://www.makeithappenphilly.org" target="_blank" rel="noreferrer">www.MakeItHappenPhilly.org</a></div>
    </div>
  );
}
